/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const autographTokens = {
  ArrowBackgroundColorBaseDefault: '#f8d648',
  ArrowFontColorBaseDefault: '#000000',
  ArrowFontSizeBaseDefault: '14px',
  ArrowFontWeightBaseDefault: '400',
  ArrowFontLeadingBaseDefault: '20px',
  InputFontFamilyBaseDefault: 'dancingscript, cursive',
  InputFontSizeBaseDefault: '24px',
  InputFontColorBaseDefault: '#1c2222',
  InputBorderBottomColorBaseDefault: '#394040',
  InputBorderBottomColorBaseKeyboardFocus: '#285da3',
  InputBorderBottomColorInvalidDefault: '#c41936',
  InputBackgroundColorBaseKeyboardFocus: '#ffffff',
  HelpFontSizeBaseDefault: '12px',
  HelpMarginTopBaseDefault: '4px',
} as const;
